import PropTypes from "prop-types"
import React from "react"
import ContentHalfList from "@organisms/ContentHalfList/ContentHalfList"
import Slider from "@organisms/Slider/Slider"
import Section from "@atoms/Section/Section"
import { IMAGE_PROP_TYPE } from "@helpers/constants"

const SiteTaxonomyTermPageFeed = ({ componentsData, langSlug = "fi" }) => {
  let countFlips = 0
  return componentsData.map(
    ({ name, slug, description, previewImage, sites }, index) => {
      if (index % 2 === 0) {
        const listItems = sites.map((site) => {
          return {
            listItem: {
              title: site.title,
              uri: site.uri,
              subtitle: site.areaName,
              sourceUrl: site.previewImage.sourceUrl,
              modalItemLink1: site.modalLink1,
              modalItemLink2: site.modalLink2,
            },
          }
        })

        countFlips++

        return (
          <Section
            key={slug}
            breakOut
            fluidWidth
            id={slug}
            margins={index === 0 ? "mb-11" : "my-11"}
          >
            <ContentHalfList
              key={slug}
              image={previewImage}
              title={name}
              description={description}
              list={listItems}
              flip={countFlips % 2 !== 0}
            />
          </Section>
        )
      } else {
        const slides = sites.map((site) => {
          return {
            image: site.previewImage,
            title: site.title,
            subtitle: site.areaName,
            modalItemLink1: site.modalLink1,
            modalItemLink2: site.modalLink2,
            uri: site.uri,
          }
        })

        return (
          <Section
            key={slug}
            breakOut
            id={slug}
            margins={index === 0 ? "mb-11" : "my-11"}
          >
            <Slider
              title={name}
              description={description}
              theme={"dark"}
              type={"large"}
              slides={slides}
            />
          </Section>
        )
      }
    }
  )
}

export default SiteTaxonomyTermPageFeed

SiteTaxonomyTermPageFeed.propTypes = {
  componentsData: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      slug: PropTypes.string.isRequired,
      description: PropTypes.string,
      previewImage: IMAGE_PROP_TYPE.isRequired,
      sites: PropTypes.arrayOf(
        PropTypes.shape({
          title: PropTypes.string.isRequired,
          uri: PropTypes.string.isRequired,
          areaName: PropTypes.string.isRequired,
          classificationName: PropTypes.string.isRequired,
          grossArea: PropTypes.string,
          modalLink1: PropTypes.shape({
            title: PropTypes.string,
            url: PropTypes.string,
          }),
          modalLink2: PropTypes.shape({
            title: PropTypes.string,
            url: PropTypes.string,
          }),
          previewImage: IMAGE_PROP_TYPE,
        })
      ),
    })
  ).isRequired,
  langSlug: PropTypes.string,
}
